import { Grid, Link, Box } from '@mui/material';
import { HeaderShort, JFormik } from '../components';
import { routeNames } from '../config';
import * as Yup from 'yup';

export interface LoginProps {
  login?: Function;
  navigate?: Function;
}

export const Login = ({ login, navigate }: LoginProps) => {
  return (
    <Box sx={{ bgcolor: 'rgba(249,255,243,1)', paddingX: { xs: 2, sm: 3 } }}>
      <HeaderShort position="fixed" />
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100vh',
          minHeight: 640,
        }}
      >
        <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
          <JFormik
            initialValues={(resource: any) => ({ email: '', password: '' })}
            validationSchema={Yup.object({
              email: Yup.string()
                .required('Email is required')
                .email('Invalid email address'),
              password: Yup.string().required('Password is required'),
            })}
            handleSubmit={(values: any) =>
              login ? login(values) : console.info(values)
            }
            form={[
              {
                name: 'h4',
                itemType: 'typography',
                label: 'Let’s Get Started!',
                jItemProps: {
                  variant: 'h4',
                  sx: { textAlign: 'center', fontSize: { xs: 28, sm: 34 } },
                },
              },
              {
                name: 'subtitle1',
                itemType: 'typography',
                label: 'Log in to your account',
                jItemProps: {
                  variant: 'subtitle1',
                  color: 'textSecondary',
                  sx: {
                    textAlign: 'center',
                    marginTop: -1,
                    marginBottom: 3,
                    lineHeight: 1.5,
                  },
                },
              },
              {
                name: 'email',
                itemType: 'textfield',
                label: 'Email',
                jItemProps: { size: 'medium' },
              },
              {
                name: 'password',
                itemType: 'textfield',
                jItemProps: { type: 'password', size: 'medium' },
                label: 'Password',
              },
              {
                name: 'submit',
                itemType: 'button',
                jItemProps: { type: 'submit' },
                label: 'Sign In',
              },
            ]}
          />
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Link
                  component="button"
                  variant="body1"
                  sx={{ mt: 5 }}
                  onClick={() => {
                    navigate
                      ? navigate(routeNames.FORGOT_PASSWORD)
                      : console.info('forgot_password');
                  }}
                >
                  Forgot Password?
                </Link>
              </Grid>
              <Grid item>
                <Link
                  component="button"
                  variant="body1"
                  sx={{ mt: 5 }}
                  onClick={() => {
                    navigate
                      ? navigate(routeNames.SIGNUP)
                      : console.info('signup');
                  }}
                >
                  Sign Up?
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
